import React, { FC, ReactNode } from 'react';
import { Tooltip, Button } from '@mui/material';
import { CollapsableCardValue } from '@securspace/securspace-ui-kit';
import { CollapsableCardHeaderItem } from './CollapsableCardHeaderItem';
import { SlotType } from '../../types/Slots';

type CollapsableCardHeaderItemWithWarningProps = {
  label: SlotType;
  value: ReactNode;
  showWarning: boolean;
  warningMessage: string;
};

const CollapsableCardHeaderItemWithWarning: FC<CollapsableCardHeaderItemWithWarningProps> = ({
  label,
  value,
  showWarning,
  warningMessage,
}) => {
  return (
    <CollapsableCardHeaderItem
      label={label}
      value={
        showWarning ? (
          <Tooltip title={warningMessage} placement="bottom" arrow>
            <Button variant="text" color="warning" size="small" sx={{ ml: -0.67 }}>
              <CollapsableCardValue>{value}</CollapsableCardValue>
            </Button>
          </Tooltip>
        ) : (
          value
        )
      }
    />
  );
};

export { CollapsableCardHeaderItemWithWarning };